const colors = {
    neutrals: {
        black: '#111111',
        textAlpha: '#434343',
        textBeta: '#646464',
        textGamma: '#919191',
        borderAlpha: '#C7C7C7',
        borderBeta: '#E7E7E7',
        background: '#FFFFFF',
        transparent: 'rgba(0,0,0,0)'
    },
    brand: {
        primary: {
            alpha: '#F26C3A',
            beta: '#FF955B',
            gamma: '#FFB485',
            delta: '#FFD2B3',
            epsilon: '#FFEDE1'
        },
        secondary: {
            alpha: '#EB730A',
            beta: '#FD9B40',
            gamma: '#FDBC5B',
            delta: '#FDD599',
            epsilon: '#FEEACB'
        }
    },
    status: {
        success: {
            alpha: '#74A305',
            beta: '#ACC82A',
            gamma: '#C8EB3C',
            delta: '#EBF98A',
            epsilon: '#F8FFCD'
        },
        warn: {
            alpha: '#9D9801',
            beta: '#D8CD03',
            gamma: '#F8F158',
            delta: '#FCF695',
            epsilon: '#FDF9BF'
        },
        fail: {
            alpha: '#F04A33',
            beta: '#FF655B',
            gamma: '#FF9F93',
            delta: '#FED3CB',
            epsilon: '#FEECE8'
        }
    },
    addition: {
        primary: '#DF6335'
    }
};
export default colors;
//# sourceMappingURL=colors.js.map